import { WebApiRequest, HTTP_POST, HTTP_DELETE, HTTP_PUT, HTTP_GET } from "tools/webservice";
import api from "apis/serviceRegion";

export const getServiceRegions = (regionType, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getServiceRegions(regionType),
  successCallback,
  mountedRef,
});

// gets the service regions and what counties they are linked to
export const getServiceRegionsDetailed = (regionType, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getServiceRegionsDetailed(regionType),
  successCallback,
  mountedRef,
});

export const addServiceRegion = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addServiceRegion(),
  successCallback,
  errorCallback,
  mountedRef,
  payload
});

export const deleteServiceRegion = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteServiceRegion(id),
  successCallback,
  errorCallback,
  mountedRef
});

export const updateServiceRegion = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.deleteServiceRegion(payload.id),
  successCallback,
  errorCallback,
  mountedRef,
  payload
});